import client from '../../../common/client';

export const GET_PROFILE_DATA = 'GET_PROFILE_DATA';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_SCORE = 'UPDATE_USER_SCORE';
export const UPDATE_USER_HANDICAP = 'UPDATE_USER_HANDICAP';
export const UPDATE_USER_DRIVING_DISTANCE = 'UPDATE_USER_DRIVING_DISTANCE';
export const UPDATE_USER_7IRON_DISTANCE = 'UPDATE_USER_7IRON_DISTANCE';

export const updateUser = (userId, payload) => ({
  promise: client.patch(`users/${userId}`, payload),
  type: UPDATE_USER,
  payload,
});

export const updateUserScore = (userId, score) => ({
  promise: client.post(`users/${userId}/scores`, { score }),
  type: UPDATE_USER_SCORE,
  value: score,
});

export const updateUserHandicap = (userId, handicap) => ({
  promise: client.post(`users/${userId}/handicaps`, { handicap }),
  type: UPDATE_USER_HANDICAP,
  value: handicap,
});

export const updateUserDrivingDistance = (userId, distance) => ({
  promise: client.post(`users/${userId}/driving-distances`, { distance }),
  type: UPDATE_USER_DRIVING_DISTANCE,
  value: distance,
});

export const updateUser7ironDistance = (userId, distance) => ({
  promise: client.post(`users/${userId}/7iron-distances`, { distance }),
  type: UPDATE_USER_7IRON_DISTANCE,
  value: distance,
});

export const getProfileData = userId => ({
  promise: client.get(`users/${userId}?profileDataOnly=true`),
  type: GET_PROFILE_DATA,
});



// WEBPACK FOOTER //
// ./src/subscription/profile/redux/actions.js